import { useProxy } from '../hook';
import EditDD from '../../EditCADD';
import Loading from '../../../components/Loading';

const mode = 'proxy';

export default function EditddView(props) {
  const { user } = useProxy();

  if (!user) {
    return <Loading />;
  }

  return (
    <EditDD
      {...props}
      mode={mode}
    />
  );
}

